import React, { FC } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import MainLayout from 'components/main-layout/MainLayout';
import API from 'core/Api';
import { buildClientEntity } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import { useTranslation } from 'react-i18next';
import StepThree from './components/StepThree';

const Screen: FC = () => {
  const { t } = useTranslation();
  const { client } = useActiveClientContext();

  const params = useParams<{ id: string | undefined }>();

  const { isLoading, error, data } = useQuery(buildClientEntity('step-three', client), () =>
    API.get<[]>(`document-wizard/step-three/${params.id || ''}`).then(res => res.data)
  );

  return (
    <MainLayout
      title={t(params.id ? 'docWizard.editTitle' : 'docWizard.title')}
      isLoading={isLoading}
      error={error}
    >
      {data && <StepThree data={data} />}
    </MainLayout>
  );
};

export default Screen;
